import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { IoHomeOutline, IoHomeSharp } from "react-icons/io5";
import { IoStorefrontOutline, IoStorefrontSharp } from "react-icons/io5";
import { VscDashboard } from "react-icons/vsc";
import { RiAccountCircleLine } from "react-icons/ri";
import { RiKeyboardBoxLine, RiKeyboardBoxFill } from "react-icons/ri";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import Photosicon from '../assets/photos_icon.png';
import "./Navbar.css";
import { MdApps, MdCall } from 'react-icons/md';
import { BsPersonVideo2 } from "react-icons/bs";
export default function Navbar() {
  const location = useLocation(); // Get current route
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setGuid(existingUser);
      setuserlogin(true);
      const photo = Cookies.get("login_photoURL");

      setPhotoURL(photo);
    } else {
      setuserlogin(false);
    }
  }, []);
  const handleGoogleLogin = async () => {
    const userData = await signInWithGoogle();
    setUser(userData);
    setTimeout(() => window.location.reload(), 2000);
  };


  return (
    <nav className="navbar">
      <div
        onClick={() => navigate('/')}
        className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
        title="Home"
      >
        {location.pathname === '/' ? <IoHomeSharp className="icon" /> : <IoHomeOutline className="icon" />}
        <span className="button-text">Home</span>
      </div>
              
    {/* <div
        onClick={() => navigate('/ads')}
        className={`menubutton-icon ${location.pathname === '/ads' ? 'active' : ''}`}
        title="Home"
      >
        {location.pathname === '/ads' ? <BsPersonVideo2 className="icon" /> : <BsPersonVideo2 className="icon" />}
        <span className="button-text">Ads</span>
      </div>
              */}
    
      <div
        onClick={() => navigate('/phonebook')}
        className={`menubutton-icon ${location.pathname === '/phonebook' ? 'active' : ''}`}
        title="phonebook"
      >
        {location.pathname === '/phonebook' ? <MdCall className="icon" /> : <MdCall className="icon" />}
        <span className="button-text">Phonebook</span>
      </div>

      <div

        onClick={() => navigate('/dashboard')}
        className={`menubutton-icon ${location.pathname === '/dashboard' ? 'active' : ''}`}
        title="dashboard"
      >
        {userlogin == true && (
                       <img 
  src={Cookies.get("login_photoURL") || Photosicon}
  onError={(e) => { e.currentTarget.src = Photosicon; }}
  className="img-icon rounded-circle shadow hover"
/>
     
        )}
        {userlogin == false && (
          // <div className='login_button' onClick={() => navigate('/login')}>
          //   <RiAccountCircleLine className="icon" />
          // </div>
          <></>
        )}
      </div>
    </nav>
  );
};